import { useState } from 'react';

import Button from '../../components/Button';
import Text from '../../components/Text';
import { t } from '../../i18n/langue';

interface CodesDeSecoursProps {
    codes: string[];
    onContinuer: () => void;
}

/**
 * Codes de secours de l'enrôlement, affichés UNE fois. Continuer exige de cocher
 * « sauvegardés » : sans eux, un téléphone perdu = un appel au support.
 */
export default function CodesDeSecours({ codes, onContinuer }: CodesDeSecoursProps) {
    const [codesNotes, setCodesNotes] = useState(false);

    return (
        <div className="flex flex-col gap-4">
            <Text variante="titre" as="h1">{t('connexion.vosCodesDeSecours')}</Text>
            <Text variante="petit" ton="attenue" className="block leading-snug">
                {t('connexion.codesDeSecoursExplication')}
            </Text>
            <ul className="grid grid-cols-2 gap-2 rounded-xl bg-main-bg-color p-4 font-mono text-sm text-text-color">
                {codes.map((code) => <li key={code}>{code}</li>)}
            </ul>
            <Button
                libelle={t('connexion.copierLesCodes')}
                variante="secondaire"
                onPress={() => void navigator.clipboard?.writeText(codes.join('\n')).catch(() => undefined)}
                pleineLargeur
            />
            <label className="flex min-h-touch items-center gap-3 text-sm text-text-color">
                <input type="checkbox" checked={codesNotes} onChange={(e) => setCodesNotes(e.target.checked)} className="h-5 w-5" />
                {t('connexion.codesSauvegardes')}
            </label>
            <Button libelle={t('connexion.accederATriggerFlow')} onPress={onContinuer} disabled={!codesNotes} pleineLargeur />
        </div>
    );
}
